import { AxiosError } from 'axios';
import { serviceConfig } from '../../config';
import { UserData } from './types';
import { carSharingClient } from '../shared';
import { VerificationType } from '../../types';
import { NoDataError, shouldTreatAsNoData } from '../../utils/serviceError';

const endpointCarSharing = '/applicant-data/caseId';

async function getUserData(
  caseId: string,
  customerNumber: string,
  verificationType?: VerificationType,
): Promise<UserData> {
  const url = `${serviceConfig.endpoints.onfido.root}${endpointCarSharing}/${caseId}`;

  try {
    const response = await carSharingClient.get(url, {
      headers: {
        'X-CustomerNumber': customerNumber,
        ...(verificationType ? { 'X-Verification-Type': verificationType } : {}),
      },
    });

    return response.data;
  } catch (err) {
    if (err instanceof AxiosError && err.response) {
      if (shouldTreatAsNoData(err.response.status, err.response.data?.message)) {
        throw new NoDataError();
      }

      throw new Error(err.response?.data.message);
    }

    throw new Error('Failed to get user data');
  }
}

export default getUserData;
